import React, { Fragment, useEffect, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import {
	Chip,
	CircularProgress,
	makeStyles,
	TextField,
	FormControlLabel,
	useMediaQuery,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		margin: 0,
	},
	label: {
		minWidth: 120,
		marginRight: 10,
		// color: ({ disabled, touched, hover }) =>
		// 	(touched || hover) && !disabled ? theme.palette.primary.main : 'black',
	},
	container: {
		placeItems: 'normal',
		maxWidth: ({ isMobile }) => isMobile && '100%',
		width: ({ isMobile, width }) => (isMobile ? '100%' : width),
		margin: 0,
	},
}));
const AutocompleteMultipleInput = ({
	label,
	value = [],
	name,
	onChange,
	options = [],
	searchFunction,
	placeholder,
	width = '100%',
	disabled,
	limitTags = -1,
	containerClass = '',
	renderOption = false,
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [touched, setTouched] = useState(false);
	const [hover, setHover] = useState(false);
	const classes = useStyles({ isMobile, disabled, width, touched, hover });
	const [query, setQuery] = useState('');
	const [reqOptions, setReqOptions] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (touched && searchFunction) {
			setLoading(true);
			searchFunction(query)
				.then((res) => setReqOptions(res))
				.finally(console.log)
				.finally(() => setLoading(false));
		}
	}, [query, searchFunction, touched]);

	const handleInputChange = (e, newInputValue = '') =>
		setQuery(
			newInputValue
				?.toUpperCase()
				.normalize('NFD')
				.replace(/\p{Diacritic}/gu, '')
		);

	return (
		<FormControlLabel
			className={classes.container + ` ${containerClass}`}
			label={<p className={classes.label}>{label}</p>}
			labelPlacement={'top'}
			control={
				<Autocomplete
					multiple
					limitTags={limitTags}
					disabled={disabled}
					loading={loading}
					options={reqOptions?.length > 0 ? reqOptions : options}
					loadingText={
						query && loading
							? 'Cargando'
							: `Ingresa búsqueda de ${label?.toLowerCase()}`
					}
					getOptionLabel={(option) => option?.text?.toString() || ''}
					getOptionSelected={(option, value) => option.value === value.value}
					value={value}
					inputValue={query}
					onChange={(e, newValue) => {
						onChange({ target: { name, value: newValue || '' } });
						setQuery('');
					}}
					onInputChange={handleInputChange}
					renderTags={(value, getTagProps) =>
						value.map((option, index) => {
							return (
								<Chip
									key={option.value}
									label={option.text}
									{...getTagProps({ index })}
								/>
							);
						})
					}
					renderOption={(option) => (
						<React.Fragment>
							{renderOption && (
								<span
									className={`mr-lg-2 label label-lg label-inline label-light-${
										option.spanColor ? option.spanColor : 'primary'
									}`}
								>
									{option.text2}
								</span>
							)}
							{option.text}
						</React.Fragment>
					)}
					renderInput={(params) => (
						<TextField
							{...params}
							size="small"
							variant="outlined"
							className={classes.input}
							placeholder={value?.length === 0 ? placeholder || label : ''}
							onBlur={(e) => setTouched(false)}
							onFocus={(e) => setTouched(true)}
							onMouseEnter={() => setHover(true)}
							onMouseLeave={() => setHover(false)}
							InputProps={{
								...params.InputProps,

								endAdornment: (
									<Fragment>
										{loading ? (
											<CircularProgress
												color={'inherit'}
												size={20}
											/>
										) : null}
										{params.InputProps.endAdornment}
									</Fragment>
								),
							}}
						/>
					)}
				/>
			}
		/>
	);
};
export default AutocompleteMultipleInput;
